import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

// import {nameValidation, phoneValidation, emailValidation, passwordValidation, dateValidation, dateNoYearValidation, zipValidation} from '../../../../utils/itemValidation';
// import {displayPhone, displayPhoneInput, displayDate, displayDateInput, displayDateNoYear, displayDateNoYearInput, stringToDigits, formatDropdownData} from '../../../../utils/formatting';

import {ScheduleShoppingFormContainer} from '../../scheduleappointment/components/ScheduleShoppingForm';
import {ScheduleServiceFormContainer} from '../../scheduleappointment/components/ScheduleServiceForm';
import {ContactPageContainer} from '../../contact/ContactPage';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class AccountAppointment extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
      selectedForm: null,
    };
	}

	componentDidMount() {
    
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  selectShop() {
    this.setState({ selectedForm: 'SHOP' });
  }

  selectService() {
    this.setState({ selectedForm: 'SERVICE' });
  }

  selectVirtual() {
    this.setState({ selectedForm: 'VIRTUAL' });
  }

  closeAllForms() {
    this.setState({ selectedForm: null });
  }

  scrollDown() {
    scrollToComponent(this.formWrapper, {
      offset: -100, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  renderSelectView() {
    return (<div className='ScheduleAppointment'>
      <div className={'scheduleBody topSpacing'}>
        <div className={'sbText desktop600'}>Our promise to you is the very best diamond education, personal guidance, and customer service in the industry.</div>
        <div className={'sbText mobile600'}>Our promise to you is the very best diamond education, personal guidance, and customer service in the industry.</div>

        <div className='sbPrompt'>Select a Service</div>

        <div className='sbButtonRow' ref={(div) => { this.buttonRow = div; }}>
          <div className={this.state.selectedForm === 'SHOP' ? 'sbButton selected' : 'sbButton'} onClick={::this.selectShop}>
            <div className={'sbButtonIcon jewelryIcon'}></div>
            <div className='sbButtonLabel'>Shop&nbsp;In&nbsp;Store</div>
          </div>
          <div className={this.state.selectedForm === 'SERVICE' ? 'sbButton selected' : 'sbButton'} onClick={::this.selectService}>
            <div className={'sbButtonIcon bellIcon'}></div>
            <div className='sbButtonLabel'>Service&nbsp;and&nbsp;Repairs</div>
          </div>
          <div className={this.state.selectedForm === 'VIRTUAL' ? 'sbButton selected' : 'sbButton'} onClick={::this.selectVirtual}>
            <div className={'sbButtonIcon virtualIcon'}></div>
            <div className='sbButtonLabel'>Virtual&nbsp;Appointments</div>
          </div>
        </div>
        <div className='sbText'>If you prefer to bypass the form, you can contact the store nearest you by <span className='inlineLink' onClick={() => this.internalNav('locations')}>clicking here</span> or contact us at <a href='tel:8008855050' className='inlineLink'>(800) 885-5050</a></div>
      </div>
      <div className='scheduleFooterSpacer'></div>
    </div>);
  }

  renderShopForm() {
    return (<div className='ScheduleAppointment'>
      <div className='scheduleBody'>
        <div className='sbFormWrapper' ref={(div) => { this.formWrapper = div; }}>
          <ScheduleShoppingFormContainer closeMethod={::this.closeAllForms} />
          <div className='sbFormClose' onClick={::this.closeAllForms}>Back &lt;</div>
        </div>
      </div>
      <div className='scheduleFooterSpacer'></div>
    </div>);
  }

  renderServiceForm() {
    return (<div className='ScheduleAppointment'>
      <div className='scheduleBody'>
        <div className='sbFormWrapper' ref={(div) => { this.formWrapper = div; }}>
          <ScheduleServiceFormContainer closeMethod={::this.closeAllForms} />
          <div className='sbFormClose' onClick={::this.closeAllForms}>Back &lt;</div>
        </div>
      </div>
      <div className='scheduleFooterSpacer'></div>
    </div>);
  }

  renderVirtualForm() {
    return (<div className='ScheduleAppointment'>
      <div className='scheduleBody'>
        <div className='sbFormWrapper' ref={(div) => { this.formWrapper = div; }}>
          <ContactPageContainer />
          <div className='sbFormClose' onClick={::this.closeAllForms}>Back &lt;</div>
        </div>
      </div>
      <div className='scheduleFooterSpacer'></div>
    </div>);
  }

	render() {
		return <div className='AccountAppointment' ref={(div) => { this.parentForm = div; }}>
      {this.state.selectedForm === null ?
        this.renderSelectView() :
        null
      }
      {this.state.selectedForm === 'SHOP' ?
        this.renderShopForm() :
        null
      }
      {this.state.selectedForm === 'SERVICE' ?
        this.renderServiceForm() :
        null
      }
      {this.state.selectedForm === 'VIRTUAL' ?
        this.renderVirtualForm() :
        null
      }
		</div>;
	}
}
export default AccountAppointment;

function mapStateToProps(state) {
  return {

  };
}

export const AccountAppointmentContainer = connect(
  mapStateToProps,
  allActionCreators
)(AccountAppointment);


// WEBPACK FOOTER //
// ./src/components/views/account/blocks/AccountAppointment.jsx